import axios from 'axios';
import Config from '../config/config';

const { backendUrl } = Config;

const getProductsList = (params) =>
  axios.get(`${backendUrl}/api/productservice/getproducts`, { params });

const getUpsaleProducts = data =>
  axios.post(`${backendUrl}/api/productservice/getupsaleproducts`, data);

const getAvailableProducts = (data) =>
  axios.post(`${backendUrl}/api/productservice/getproductavailability`, data);

const deleteProduct = (data) =>
  axios.post(`${backendUrl}/api/productmanagement/deleteproduct`, data);

const registerProduct = data =>
  axios.post(`${backendUrl}/api/productmanagement/registerproduct`, data);

const toggleProductStockAvailability = (data) => 
  axios.post(`${backendUrl}/api/productmanagement/toggleproductstockavailability`, data);


export default {
  getProductsList,
  getAvailableProducts,
  deleteProduct,
  getUpsaleProducts,
  registerProduct,
  toggleProductStockAvailability
};
